import React, { useContext } from 'react'
import { LightMode, DarkMode } from '@mui/icons-material'
import { Box, IconButton, useTheme } from '@mui/material'
import { ColorModeContext } from '../../../../../../App'
import { ThemeWrapper } from '../../StyledComponents'

function ThemeSwitcher() {
	const theme = useTheme();
	const colorMode = useContext(ColorModeContext);

	return (
		<ThemeWrapper>
			<Box sx={{ display: { lg: 'none' } }}>Change Theme:</Box>
			<IconButton onClick={colorMode.toggleThemeMode}>
				{theme.palette.mode === 'light' ? <DarkMode /> : <LightMode />}
			</IconButton>
		</ThemeWrapper>
	)
}

export default ThemeSwitcher
